<template>
    <div class="content">
        <h3 class="mt-2 mb-5 ml-2 is-hidden-desktop"><i class="fal fa-truck fa-fw mr-3"></i>Vendor Information</h3>

        <!-- Free-text trip-level vendor notes -->
        <div class="white-container content ql-editor" v-if="trip.app_vendor" v-html="trip.app_vendor"></div>

        <!-- Auto-compiled vendor info pulled from every itinerary event that has it -->
        <div class="mt-5" v-if="loading">
            <h5 class="has-text-grey"><i class="fal fa-tennis-ball fa-spin mr-3"></i>Gathering vendor info from the itinerary...</h5>
        </div>
        <div class="mt-5" v-else-if="eventVendors.length">
            <h5 class="ml-2 mb-4"><i class="far fa-list-ul fa-fw mr-2"></i>Vendors by Event</h5>
            <div class="white-container">
                <div class="vendor-item" v-for="item in eventVendors" :key="item.key">
                    <div class="vendor-source">
                        <span class="event-title">{{ item.eventTitle }}</span>
                        <span class="event-meta" v-if="item.dayTitle"> &middot; {{ item.dayTitle }}</span>
                        <span class="event-meta" v-if="item.dayOn"> &middot; {{ item.dayOn | moment('ddd, MMM Do YYYY') }}</span>
                    </div>
                    <div class="content ql-editor" v-html="item.vendor_info"></div>
                </div>
            </div>
        </div>

        <!-- Nothing at all yet -->
        <div class="white-container content has-text-centered" v-if="!trip.app_vendor && !loading && !eventVendors.length">
            <h4 class="pt-6 pb-6 has-text-grey"><i class="fal fa-message-captions mr-2"></i> More information will be available later.  Check back soon!</h4>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import {client as http} from "../../http_client";

    export default {
        data: function() {
            return {
                loading: false,
                itinerary: []
            };
        },
        computed: {
            ...mapGetters(['trip', 'registration']),
            // Flatten every itinerary event that carries vendor info, labelled with
            // the event it came from so it's all viewable in one place.
            eventVendors: function() {
                const result = [];
                (this.itinerary || []).forEach(day => {
                    (day.events || []).forEach(event => {
                        if (event.active === '0') return;
                        const vendor = (event.day_event && event.day_event.vendor_info) || event.vendor_info;
                        if (!vendor) return;
                        const eventTitle = (event.day_event && event.day_event.title) || event.title;
                        result.push({
                            key: day.id + '-' + event.type + '-' + event.id,
                            eventTitle: eventTitle || 'Event',
                            dayTitle: day.title,
                            dayOn: day.day_on,
                            vendor_info: vendor
                        });
                    });
                });
                return result;
            }
        },
        methods: {
            loadVendors: function() {
                if (!this.registration.id) return;
                this.loading = true;
                http.get('/app/registrations/' + this.registration.id + '/itinerary').then(response => {
                    this.itinerary = response.data || [];
                    this.loading = false;
                }).catch(() => {
                    this.loading = false;
                });
            }
        },
        watch: {
            registration: function() {
                this.loadVendors();
            }
        },
        mounted() {
            this.loadVendors();
        }
    };
</script>

<style lang="scss" scoped>
    .vendor-item {
        padding-bottom: 0.9rem;
        margin-bottom: 0.9rem;
        border-bottom: 1px solid #ededed;

        &:last-child {
            padding-bottom: 0;
            margin-bottom: 0;
            border-bottom: 0;
        }

        // Trim the leading/trailing whitespace the rich-text editor adds so rows sit tight.
        .ql-editor {
            padding: 0;

            > :first-child { margin-top: 0; }
            > :last-child { margin-bottom: 0; }
        }
    }

    .vendor-source {
        border-left: 3px solid #628b21;
        padding-left: 0.7rem;
        margin-bottom: 0.4rem;

        .event-title {
            font-weight: 700;
        }

        .event-meta {
            color: #6b6b6b;
            font-size: 0.85rem;
        }
    }
</style>
